import Fade from '@mui/material/Fade';
import Box from '@mui/material/Box';

import { useAppThemeContext } from '../../context/AppThemeProvider';
import Spinner from '../Spinner/Spinner';

/**
 * Covers the app while its branding is unknown, on a device that has none
 * cached (the first visit, or the first load after a sign-out). Without it
 * that load showed the MyFitWorld colours and logo, then the tenant's, then
 * the organization's rebrand. With a cached branding there is nothing to
 * hide — `main.tsx` has already painted it — so this never shows.
 *
 * An overlay rather than a gate: the providers under it have to mount and
 * fetch for the branding to settle at all. `AppThemeProvider` bounds the wait
 * (`BRANDING_SETTLE_TIMEOUT_MS`).
 */
export const BrandingLoader = () => {
  const { hasCachedBranding, isBrandingReady } = useAppThemeContext();

  if (hasCachedBranding) return null;

  return (
    <Fade in={!isBrandingReady} appear={false} timeout={200} unmountOnExit>
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: 'var(--mfw-palette-background-default)',
          display: 'flex',
          inset: 0,
          justifyContent: 'center',
          position: 'fixed',
          zIndex: 'tooltip',
        }}
      >
        <Spinner size="large" />
      </Box>
    </Fade>
  );
};
